import LibraryTable from "@/components/LibraryTable";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/library/folder/$folderId",
)({
  component: FolderView,
});

function FolderView() {
  const { folderId } = Route.useParams();
  return <LibraryTable folderId={folderId} />;
}
